import React from 'react'
import './StepCount.scss'


const StepCount = ({step, maxStepCount}) =>  (
    (step !== 0 &&
        <div className="mt100">          
            <div className='step-count'>
            {[...Array(maxStepCount)].map((_, index) => {
                    const currentStep = index + 1;
                    let className = 'square';
                    if (step === currentStep) {
                        className += ' active';
                    }
                    else if (step > currentStep) {
                        className += ' passed';
                    }
                    return (
                        <div key={currentStep} className={className}>{currentStep}</div>
                    );
                })}
            </div>
        </div>  
    )
);

export default StepCount